import { useTranslation } from 'react-i18next';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetInterestSectorsQuery } from '@api/interestSector.api';

interface InterestSectorSelectorProps extends MultiSelectProps {
  marketCategoryName: string;
}

export default function InterestSectorSelector({
  marketCategoryName,
  ...props
}: InterestSectorSelectorProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetInterestSectorsQuery(
    marketCategoryName,
    { skip: marketCategoryName === undefined },
  );

  return (
    <MultiSelect
      label={t('selectors.interestSector.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.interestSector.placeholder')
      }
      data={data.map((sector) => ({
        label: sector.name,
        value: sector.id.toString(),
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
